<template>
  <div id="home" :ref="test ? '' : 'homeRef'" :class="{ position: !test }">
    <div class="bg">
      <div class="bg-fize">{{ bgName }}</div>
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body d-flex jc-center">
        <left />
        <center />
        <right />
      </div>
    </div>
  </div>
</template>

<script>
import HomeResizeMixin from '@/utils/HomeResizeMixin';
import left from './left.vue';
import center from './center.vue';
import right from './right.vue';
import { countyMine } from '@/api/area/left2';

export default {
  mixins: [HomeResizeMixin],
  data() {
    return {
      loading: true,
      bgName: '区资源中心-数据大屏',
      test: true // true的时候，不使用屏幕适配，用于开发时看效果
    };
  },
  components: { left, center, right },
  async mounted() {
    // await this.countyMine();
    await this.cancelLoading();
  },
  methods: {
    async countyMine() {
      const data = await countyMine();
      const res = data.data?.visualTitle;
      this.bgName = res ? res : '融合教育大数据平台';
    },
    async cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
#home {
  width: 1920px * 3;
  height: 1080px;
  overflow: hidden;
  background-color: #0a1531;
  &.position {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: left top;
  }

  .bg {
    width: 100%;
    height: 100%;
    background-image: url('~@/assets/images/title.png');
    background-repeat: no-repeat;
    background-position: center top;
    position: relative;
    .bg-fize {
      font-weight: 600;
      font-size: 43px;
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translate(-50%, -50%);
      letter-spacing: 0.1em;
      background-image: linear-gradient(#fff, #409eff);
      -webkit-background-clip: text;
      color: transparent;
    }
  }
}
</style>
